import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";
import GameScene from "../../../scenes/GameScene";

export default class NPCFishMonster extends NPC {
    constructor() {
        super(definitions.NPC_ID.FISH_MONSTER);

        this._moved = false;
        this.collisionRadius = 150;
        this.collisionOffsetX = -14;
        this.collisionOffsetY = -30;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("boss_fish_monster_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LAoRGE, 0.6, new PIXI.Point(8, -12));
        this.animateIdle(0.7);

        if(GameScene.active.questManager.isQuestComplete('quest_1', 'fish_monster')) {
            this.moveToDefeatedPosition();
        }
    }
    
    onViewAdded() {
        super.onViewAdded();

        this.status.x += 37;
    }
    
    moveToDefeatedPosition() {
        if (this._moved) {
            return;
        }

        this._moved = true;
        this.x += 350;
        this.y += 100;
        this.scale.x = -1;
    }
}